import React from "react";
import Imagen from "../../images/modulo12/conclusion12.png";
import LayoutActividad from "../../components/LayoutActividad";

import { modulo12 } from "../../routes/Module12";
import { modulo13 } from "../../routes/Module13";

import Sidebar from "./Sidebar";
import GuiaDocente from "../../components/GuiaDocente";

const Modulo1Conclusion = () => {
  const crumbs = [
    {
      title: modulo12.title,
      url: "/" + modulo12.url,
    },
    {
      title: `Cierre`,
      url: "cierre",
    },
  ];
  const pages = {
    titlePrev: `${modulo12.content[0].name} - ${modulo12.content[0].activities[10].name}`,
    linkPrev: `${modulo12.url}/${modulo12.content[0].path}/${modulo12.content[0].activities[10].path}`,
  };
  const metadata = {
    color: modulo12.color,
    title: `${modulo12.title}`,
    name: modulo12.title,
  };
  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <h1 className="my-5">Entonces, ¿quiénes somos los peruanos?</h1>

      <div className="header-img">
        <img src={Imagen} className="card-img-top full-width" alt="..." />
      </div>

      <GuiaDocente>
        <ul>
          <li>
            Pida que observen con detenimiento la imagen presentada. Dé tiempo
            suficiente para que lean los diálogos y puedan reconocer los
            detalles que ofrece la ilustración. Otorgue los roles de los
            personajes a algunos niños y niñas y pídales que lean los diálogos
            en voz alta. Elabore algunas preguntas:
            <ul>
              <li>
                <i>
                  “¿En dónde se encuentran los personajes? (Posible respuesta:
                  En el mercado).
                </i>
              </li>
              <li>
                <i>
                  ¿Cuál es el problema principal? (Posible respuesta: El mercado
                  está muy sucio).
                </i>
              </li>
              <li>
                <i>
                  ¿Qué soluciones se presentan al problema? (Posible respuesta:
                  Algunos quieren cerrar el mercado, otros quieren limpiarlo y
                  pedirle ayuda a la municipalidad).”
                </i>
              </li>
            </ul>
          </li>

          <li>
            Señale que a lo largo de la unidad se ha trabajado la convivencia,
            la deliberación y la participación. Resalte cómo se relaciona la
            imagen con estas capacidades. Por ejemplo:
            <ul>
              <li>
                <i>
                  “En el mercado conviven diversas personas. En esta convivencia
                  se presenta el problema de la suciedad del mercado que hace,
                  por ejemplo, que algunos no quieran comprar allí o que
                  reclamen a sus vendedores. Ante estos problemas es importante
                  deliberar, es decir, tener una conversación en la que se
                  escuchen distintos puntos de vista sobre el problema. Hemos
                  visto que algunos quieren cerrar el mercado, otros quieren
                  limpiarlo. Algunas veces se llegará a un acuerdo y otras
                  veces, no. A partir de ello, se pueden tomar decisiones para
                  participar en la toma de decisiones que lleven a solucionar el
                  problema. En esta imagen algunos quieren limpiar el mercado y
                  pedirle ayuda a la municipalidad. A ello se suman otras
                  acciones para mejorar el mercado y que sea de acceso a todas
                  las personas, como por ejemplo, la construcción de rampas.”
                </i>
              </li>
            </ul>
          </li>

          <li>
            Ahora retome la pregunta principal: Entonces, ¿quiénes somos los
            peruanos? Para responderla, guíe a los niños y niñas en la
            discusión:
            <ul>
              <li>
                <i>
                  ¿Somos todos los peruanos iguales? ¿En qué nos diferenciamos?
                </i>
              </li>
              <li>
                <i>
                  ¿Desde cuándo existe diversidad? ¿Podemos decir que es una
                  situación nueva?
                </i>
              </li>
              <li>
                <i>
                  ¿Qué problemas y ventajas trae la diversidad para la
                  convivencia?
                </i>
              </li>
              <li>
                <i>
                  ¿Cómo colaboran la deliberación y la participación para una
                  mejor convivencia entre peruanos?.
                </i>
              </li>
            </ul>
          </li>
        </ul>
      </GuiaDocente>

      <div className="unit-options my-5 d-flex flex-column">
        <p>Ir al siguiente módulo:</p>
        <a href={"/" + modulo13.url}>
          <button className={`btn btn-${modulo12.color} me-2`}>
            {modulo13.title + " >"}
          </button>
        </a>
      </div>
    </LayoutActividad>
  );
};

export default Modulo1Conclusion;
